import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { buildPageTitle } from '@/shared/lib/page-title'
import { RankingListPage } from '@/features/ranking'

const rankingSearchSchema = z.object({
  tab: z.enum(['global', 'group', 'schools']).optional(),
  group: z.coerce.number().optional()
})

export const Route = createFileRoute('/_authenticated/_main/ranking')({
  validateSearch: rankingSearchSchema,
  head: () => ({
    meta: [{ title: buildPageTitle('Ranking') }]
  }),
  component: RankingListPage
})
